export const checkedIconStyle = {
  borderRadius: '4px',
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
